import actionTypes from 'src/modules/redux/actionTypes'

export const setElements = elements => ({
  type: actionTypes.SET_SIDEBAR_USERS,
  payload: elements
})
